import { render, staticRenderFns } from "./album-group.vue?vue&type=template&id=7375dcea&scoped=true"
import script from "./album-group.vue?vue&type=script&lang=ts"
export * from "./album-group.vue?vue&type=script&lang=ts"
import style0 from "./album-group.vue?vue&type=style&index=0&id=7375dcea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7375dcea",
  null
  
)

export default component.exports